import { easeCubic } from 'd3-ease';

export const variants = {
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.2, ease: easeCubic },
    },
    hidden: {
        opacity: 0,
        y: 10,
        transition: { duration: 0.2, ease: easeCubic },
    },
};
